import React from 'react'
import { useStore } from '../../lib/context'
import { observer } from 'mobx-react-lite'
import { motion } from 'framer-motion'
import { useLocation } from '@reach/router'

const DesktopLogo = observer(({ animated }) => {
	const {
		uiStore: { navBar__textColor },
	} = useStore()

	const location = useLocation()

	const onHomePage =
		location?.pathname === '/' ||
		location?.pathname === '/business' ||
		location?.pathname === '/being'
	const animate = { fill: navBar__textColor }
	const transition = { delay: animated ? 0.5 : 0, duration: animated ? 0.8 : 0 }
	return (
		<>
			<svg
				className={onHomePage ? 'shift' : ''}
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 2727.05 652.25"
			>
				<g>
					<g>
						<path d="M2236.43,199.84l87.62-106.17a21.29,21.29,0,0,1,17.38-9H2462A21.28,21.28,0,0,1,2483.27,106V546.3A21.28,21.28,0,0,1,2462,567.58H1976.7a21.28,21.28,0,0,1-21.28-21.28V106a21.28,21.28,0,0,1,21.28-21.28h120.56a21.29,21.29,0,0,1,17.38,9l87.62,106.17a20.93,20.93,0,0,0,17.09,8.84h0A20.93,20.93,0,0,0,2236.43,199.84Z" />
						<rect
							x="642.68"
							y="84.68"
							width="161.43"
							height="482.9"
							rx="21.28"
						/>
						<path d="M590.68,432.28a135.69,135.69,0,0,1-19.84,62.82c-19.33,31-50.3,53.32-85,64.18a188.51,188.51,0,0,1-56.26,8.3H106A21.28,21.28,0,0,1,84.68,546.3V106A21.28,21.28,0,0,1,106,84.68H411.87c36.47,0,74.2,7.93,103.92,30.05,29,21.58,46.47,56,52.92,89.45,8.15,42.29-4.47,79.9-25.77,108.94-3.56,4.87,5.77,11,8.62,13.9,12,12.15,22,24.94,28.61,40.76A144,144,0,0,1,590.68,432.28Z" />
						<path d="M1104.86,574.47c-136.72,0-248.12-110.15-249-247.34-.9-136.83,107.86-247.66,244.67-250,139.27-2.38,253.4,109.58,253.4,248.31C1353.9,463.41,1242.14,574.47,1104.86,574.47Z" />
						<path d="M1654.66,574.47c-136.72,0-248.12-110.16-249-247.34-.9-136.84,107.86-247.67,244.68-250,139.26-2.38,253.39,109.58,253.39,248.31C1903.7,463.41,1791.94,574.47,1654.66,574.47Z" />
						<path d="M2561.88,98.45a3.82,3.82,0,0,1,1-.67l-6.32-.34V84.68h26.64V98H2582a13.36,13.36,0,0,0-9.71,3.84c-3.27,3.16-5,8.47-5,14.57,0,5.53,1.46,9.93,4.17,12.64a11.65,11.65,0,0,0,8.13,3,9.83,9.83,0,0,0,7.45-2.94c2.71-2.71,4.63-7.11,6.1-13.43l1.81-7.9c1.8-7.68,4.4-13.1,8-16.71,3.84-3.73,8.92-5.42,15.24-5.42A23.43,23.43,0,0,1,2635,92.36c4.62,4.63,7.33,11.29,7.33,19.3,0,7.12-2.25,13.33-6.66,17.5a1.54,1.54,0,0,1-.79.68l6.33.34V142.6h-25.52V129.28h1.58a11.57,11.57,0,0,0,8.58-3.39c2.71-2.6,4.18-6.77,4.18-11.86,0-4.4-1.36-7.9-3.73-10.27a11.06,11.06,0,0,0-8.13-3.16,8.73,8.73,0,0,0-6.54,2.6c-2.15,2-3.73,5.75-5,11.29l-1.58,7.33c-1.92,8.81-4.86,15.13-8.92,19.08s-9.26,5.88-15.7,5.88c-7.22,0-13.32-2.49-17.72-7-5.08-5.08-8-12.65-8-21.57C2554.76,110,2557.25,103.08,2561.88,98.45Z" />
						<path d="M2568.42,154.34V159a3.56,3.56,0,0,0,3.84,3.84h53.29a3.56,3.56,0,0,0,3.84-3.84v-4.63h11.86v62.33h-25.86V203.8h10.16a3.6,3.6,0,0,0,3.84-4V176h-22.13v21.34h-12.08V176h-26.76v25.52a3.59,3.59,0,0,0,3.84,4H2584v12.87h-27.43v-64Z" />
						<path d="M2568.42,227.4V230a5.14,5.14,0,0,0,3.5,5.08l57.47,21.45V246.14h11.86v30.48l-69.33,25.86a5.12,5.12,0,0,0-3.5,5.08v2.6h-11.85V278h11.85V282c0,3.84,2.38,5.76,6.21,4.41l8.25-2.71V253.37l-8.25-2.71c-3.83-1.36-6.21.56-6.21,4.51v4h-11.85V227.4Zm26.2,52.39L2628,268.61l-33.42-11.18Z" />
						<path d="M2561.88,332.52a3.82,3.82,0,0,1,1-.68l-6.32-.34V318.75h26.64v13.32H2582a13.36,13.36,0,0,0-9.71,3.84c-3.27,3.16-5,8.46-5,14.56,0,5.53,1.46,9.94,4.17,12.65a11.65,11.65,0,0,0,8.13,3,9.86,9.86,0,0,0,7.45-2.93c2.71-2.71,4.63-7.11,6.1-13.44l1.81-7.9c1.8-7.68,4.4-13.1,8-16.71,3.84-3.72,8.92-5.42,15.24-5.42a23.47,23.47,0,0,1,16.83,6.66c4.62,4.63,7.33,11.29,7.33,19.31,0,7.11-2.25,13.32-6.66,17.5a1.64,1.64,0,0,1-.79.68l6.33.34v12.41h-25.52V363.34h1.58a11.6,11.6,0,0,0,8.58-3.38c2.71-2.6,4.18-6.78,4.18-11.86,0-4.4-1.36-7.9-3.73-10.27a11,11,0,0,0-8.13-3.16,8.73,8.73,0,0,0-6.54,2.59c-2.15,2-3.73,5.76-5,11.29l-1.58,7.34c-1.92,8.81-4.86,15.13-8.92,19.08s-9.26,5.87-15.7,5.87c-7.22,0-13.32-2.48-17.72-7-5.08-5.08-8-12.64-8-21.56C2554.76,344,2557.25,337.15,2561.88,332.52Z" />
						<path d="M2598.57,388c24.84,0,43.8,18.63,43.8,43.35,0,25-19,43.47-43.8,43.47s-43.81-18.51-43.81-43.47C2554.76,406.58,2573.84,388,2598.57,388Zm0,72.82c17.72,0,30.93-12.53,30.93-29.47S2616.29,402,2598.57,402c-17.5,0-30.82,12.31-30.82,29.35S2581.07,460.77,2598.57,460.77Z" />
						<path d="M2568.42,480.3v4.63a3.56,3.56,0,0,0,3.84,3.84h53.29a3.56,3.56,0,0,0,3.84-3.84V480.3h11.86v19.42l-60,46.74h44.26a3.56,3.56,0,0,0,3.84-3.84v-9.37h11.86v34.33h-11.86v-3.5a3.56,3.56,0,0,0-3.84-3.84h-69V549.62l60.63-47.19h-44.94a3.59,3.59,0,0,0-3.84,3.95v9.37h-11.85V480.3Z" />
					</g>
				</g>
			</svg>
			<style jsx>{`
				svg {
					display: block;
					height: 100%;
				}
				path,
				rect {
					fill: ${navBar__textColor};
				}

				.shift path,
				.shift rect {
					animation-name: backgroundColorPalette;
					animation-duration: 10s;
					animation-iteration-count: infinite;
					animation-direction: alternate;
					animation-timing-function: linear;
				}

				@keyframes backgroundColorPalette {
					0% {
						fill: #ffe01b;
					}
					25% {
						fill: #dbff00;
					}
					50% {
						fill: #ff84e0;
					}
					75% {
						fill: #79e986;
					}
					100% {
						fill: #ff7640;
					}
				}

				@media only screen and (max-width: 768px) {
					svg {
						display: none;
					}
				}
			`}</style>
		</>
	)
})

export default DesktopLogo
